export default {
  blue: {
    title: '多期贷',
    titlebar: '多期贷',
    register: {
      title: '多期贷注册及使用协议'
    }
  },
  hangban: {
    title: '读秒',
    titlebar: '读秒',
    rongyituiBar: '百花信风',// 20210317 这里是接融易推的时候走的hangban的标题,但是我方法务要求改成百花信风,所以万般无奈之下只能在这儿改了,见谅.lingjuan.guan
    register: {
      title: '注册及使用协议'
    }
  },
  meitu: {
    title: '现金分期',
    titlebar: '现金分期',
    register: {
      title: '注册及使用协议'
    }
  },
  default: {
    title: '读秒',
    titlebar: '读秒钱包',
    rongyituiBar: '百花信风',
    register: {
      title: '注册及使用协议'
    }
  }
}
